import { easepick, LockPlugin, RangePlugin } from '@easepick/bundle';

const initDatePicker = () => {
  const pickerInput = document.querySelector<HTMLInputElement>('[data-el="datepicker"]');
  const datePresentationInput = document.querySelector<HTMLInputElement>(
    '[data-el="presentation-date"]'
  );

  function getAvailableSpace(el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    return {
      above: rect.top,
      below: windowHeight - rect.bottom,
      height: rect.height,
    };
  }

  if (!pickerInput || !datePresentationInput) return;

  const picker = new easepick.create({
    element: pickerInput,
    css: [
      'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
      // 'http://localhost:3000/components/datepicker.css',

      'https://cdn.jsdelivr.net/npm/@engine-web/website@0/dist/components/datepicker.css',
    ],
    zIndex: 1000,
    grid: 2,
    calendars: 2,
    readonly: false,
    locale: {
      apply: 'Close',
    },
    autoApply: false,
    LockPlugin: {
      minDate: new Date(),
    },

    plugins: [RangePlugin, LockPlugin],

    RangePlugin: {
      tooltipNumber(num) {
        return num - 1;
      },
      locale: {
        one: 'night',
        other: 'nights',
      },
    },

    setup(picker) {
      const updatePosition = () => {
        const input = picker.options.element;
        if (typeof input === 'string') return;
        const pickerEl = picker.ui.container;
        const space = getAvailableSpace(input);

        pickerEl.style.position = 'absolute';

        if (space.below >= 420) {
          // Place below
          pickerEl.style.top = `${input.offsetTop + input.offsetHeight}px`;
          pickerEl.style.transform = 'translateY(0)';
        } else if (space.above >= 420) {
          // Place above
          pickerEl.style.top = `${input.offsetTop - pickerEl.offsetHeight + 17}px`;
          pickerEl.style.transform = 'translateY(0)';
        } else {
          // Center vertically
          const centerTop = input.offsetTop + input.offsetHeight / 2 - pickerEl.offsetHeight / 2;
          pickerEl.style.top = `${centerTop}px`;
          pickerEl.style.transform = 'translateY(0)';
        }

        pickerEl.style.left = `${input.offsetLeft}px`;
      };

      picker.on('show', updatePosition);
      window.addEventListener('scroll', updatePosition, true);
      window.addEventListener('resize', updatePosition);
    },
  });

  function formatDateRange(startDateStr: string, endDateStr: string) {
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const startMonth = monthNames[start.getMonth()];
    const startDay = start.getDate();

    const endMonth = endDateStr ? monthNames[end.getMonth()] : '';
    const endDay = endDateStr ? end.getDate() : '';

    if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
      return `${startMonth} ${startDay} - ${endDay}`;
    }
    return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
  }

  function formatDateToYRMMDD(dateStr: string) {
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yr = String(date.getFullYear());

    return `${yr}-${mm}-${dd}`;
  }

  picker.on('preselect', (e) => {
    const { end, start } = e.detail;
    datePresentationInput.value = formatDateRange(start, end);
    pickerInput.value = `${formatDateToYRMMDD(start)} - ${end ? formatDateToYRMMDD(end) : ''}`;
    pickerInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
};

export default initDatePicker;
